export const LOAD_TRUE = 'LOAD_TRUE'
export const LOAD_FALSE = 'LOAD_FALSE'
export const UPDATE_USER = 'UPDATE_USER'